/* Versie 2: WITH GET/PUT/POST/DELETE callServer[proto] and optional post/url */

import axios from 'axios';
import util from './AppUtil';
//import server from '../server';
import {MessageBox} from 'element-ui'

const myAxios = axios.create({
  responseType : 'json',
  headers: { "content-type": "application/json"   }
});
// headers: { "content-type":"application/json; charset=utf-8"}

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

export default {
    QID     : "",       // Forward QID (using Initialize()
    allowed : false,    // User has access?

    pagewidth: 0,
    axios: myAxios,
    header : [],
    payload : [],
    codes : [],

    getAuthMode: function(ulevel,target) {
      return [ulevel >= 5,ulevel >= 4, ulevel >= 4];
    },

    Initialize: function(router,qid) { // Check Auth and return qid for local use.
        this.QID = qid;
        this.allowed = this.IsAllowed(router,this.QID);
        if (!this.allowed) this.Forward(router,"XLI",null);
        return qid;
    }, 
    // ------------------------------------------------------------------------------------
    // EASY-PEASY functies tbv onderscheid tussen C# en OE data providers, OE [0], C# niet.
    // ------------------------------------------------------------------------------------
    processMainResults: function (result) {    
      var d = result.data;
      if (typeof(d) === "string") d = JSON.parse(result.data);   // convert aws string to object.

      if (d.header)  this.header  = d.header;
      else this.header = [];
 
      if (d.payload) this.payload = d.payload;
      else this.payload = [];
      
      if (d.codes)   this.codes   = d.codes;
      else this.codes = [];
        
    },    
    
    getMainCode: function(codename) {
      if (this.codes[codename] != 'undefined') return this.codes[codename];
      else return {};
    },
    
    getMainPayload: function(item) {
       if (this.payload)
       {
         if (this.payload[item] != 'undefined') return this.payload[item];
         else return this.payload;
       }
       else return {};
    },

    getSubPayload: function(result,item) {
      var subpayload = [];
      if (result.data.payload) subpayload = result.data.payload;

      if (subpayload[item] != 'undefined') return subpayload[item];
      else return [];
    },

    getMainHeader: function(name) {
      if (this.header[name] != 'undefined') return this.header[name];
      else return "";
    },

    getSubHeader: function(result,name) {
      var subheader = {};
      if (result.data.header != 'undefined') subheader = result.data.header;
      
      if (subheader[name] != 'undefined') return subheader[name];
      else return "";
    },

    // ----------------------------------------------------------------------------------

    cloneParam: function(input) {
      var cloned = JSON.parse(JSON.stringify(input));
      return cloned;
    },

    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },

    saveLocal: function(code,value) {
      if (typeof(window.localStorage)        !== "undefined") 
         return window.localStorage.setItem(code,value);
      else if (typeof(window.sessionStorage) !== "undefined") 
         return window.sessionStorage.setItem(code,value); 
    },

    getLocal: function(code) {
      if (typeof(window.localStorage)        !== "undefined") 
         return window.localStorage.getItem(code);
      else if (typeof(window.sessionStorage) !== "undefined") 
         return window.sessionStorage.getItem(code); 
      else return "";
    },
    
    arrayToArg: function(array_in) {
      if (array_in == null) return "";
      var out = new Array();
      for(var key in array_in){
        out.push(key + '=' + array_in[key]);
      }
      return out.join('&');
    },

    getStageUrl: function(url) {
      var stage = window.stage;
      url = url.replace("{stage}",stage);
      return url;

    },

    /* --------------- GET ---------------- */
    callServerGet: function (servermode,mainpage,array_in,cmd='list') { 
      var bearer = "Bearer " + window.sessionStorage.getItem('token');
      array_in["Module"]   = mainpage;
      array_in["Action"]   = cmd;   
      array_in["WebStage"] = window.stage;
      array_in["Token"]    = window.sessionStorage.getItem('token');   
      var parlist = this.arrayToArg(array_in);
      return myAxios.get(this.getStageUrl(window.apiserver[servermode]),{headers: {'Authorization': bearer}});
    },      
    
    /* --------------- POST --------------- */
    callServerPost: function (servermode,mainpage,array_in,cmd='save') {      
      var bearer = "Bearer " + window.sessionStorage.getItem('token');     
      array_in["Module"]   = mainpage;
      array_in["Action"]   = cmd;   
      array_in["WebStage"] = window.stage;
      array_in["Token"]    = window.sessionStorage.getItem('token');   

      return myAxios.post(this.getStageUrl(window.apiserver[servermode]),array_in,{headers: {'Authorization': bearer}}); 
    },      
    /* --------------- PUT ---------------- */
    
    callServerPut: function (servermode,mainpage,array_in,cmd='add') {
      var bearer = "Bearer " + window.Bearer; //window.sessionStorage.getItem('token');
      array_in["Module"]   = mainpage;
      array_in["Action"]   = cmd;   
      array_in["WebStage"] = window.stage;
      array_in["Token"]    = window.sessionStorage.getItem('token');   
      return myAxios.put(this.getStageUrl(window.apiserver[servermode]),array_in,{headers: {'Authorization': bearer}});
    },      
    
    /* ------------- DELETE --------------- */
    
    callServerDelete: function (servermode,mainpage,array_in,cmd="del") {
      var bearer = "Bearer " + window.Bearer; //window.sessionStorage.getItem('token');
      array_in["Module"]   = mainpage;
      array_in["Action"]   = cmd;   
      array_in["WebStage"] = window.stage;
      array_in["Token"]    = window.sessionStorage.getItem('token');   
      return myAxios.delete(this.getStageUrl(window.apiserver[servermode]),array_in,{headers: {'Authorization': bearer}}); 
    },      
    
    
    callServer: function (servermode,mainpage,params) {  // Backwards compatibility...
      return this.callServerPost(servermode,mainpage,params,false);
    },      


    serverError(parent) {
      parent.$message({
 			     	   title: "System Error",type: 'error',
               duration: 500,
               dangerouslyUseHTMLString: true,
   			  	   message: "<div style='line-height:30px;margin:20px;xtop:50px;font-size:20px'>The server seems to be down or not responding." + 
                        "<br>Try again later and contact admin when problem persists!</div>"
     		  	 });

          parent.listLoading = false;
    },

    message: function(type,msg) {
        MessageBox.confirm(msg,
        type,
        {
          confirmButtonText: "OK",
         type: "warning"
        });
    },


    formatMoney: function(value) {
      var formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
 	  	
    
    formatDate: {

        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    
    // --------------------------------- QUICK-ITEM CALL ---------------------------------

    Forward : function (router,id,parg) {
      var i = 0;
      var j = 0;
      var fto = "";
      for(i = 0;i < router.options.routes.length;i++) {
        if (router.options.routes[i].qid == id) {
          fto = router.options.routes[i].name;
          break;
        }
        if (router.options.routes[i].children)
        {
          for(j = 0;j < router.options.routes[i].children.length;j++) {
            if (router.options.routes[i].children[j].qid == id) {
              fto = router.options.routes[i].children[j].name;
              break;
            }
          }
        }
      }     
      if (fto != "") {
        if (window.apidebug == 1)
          console.log("* " + id + " -> " + fto);
        router.push({name: fto,params: parg});
      }
      //else console.log("ERROR: Could not file QID '" + id + "' in router.js");
    },

    IsAllowed: function (router,id) {         
      var i = 0;
      var j = 0;
      var roles = this.user("roles");
      var depts = this.user("depts");

      if (roles=="#S#" || id == "*") this.allowed = true;
      else if (roles == null) {
        console.log("Util.IsAllowed: NO user roles can be found!!!");
        this.allowed = false;
      }
      else {
        for(i = 0;i < router.options.routes.length;i++) {
          if (router.options.routes[i].qid == id) {
            this.allowed = roles.includes(router.options.routes[i].role);
            //this.allowed = this.allowed && depts.includes(router.options.routes[i].dept);
            break;
          }
          if (router.options.routes[i].children)
          {
            for(j = 0;j < router.options.routes[i].children.length;j++) {
              if (router.options.routes[i].children[j].qid == id) {
                this.allowed = roles.includes(router.options.routes[i].children[j].role);
                this.allowed = this.allowed && depts.includes(router.options.routes[i].children[j].dept);
                break;
              }
            }
          }
        }
      }     
      //console.log("Check auth for QID: '" + id + "' Roles: '" + roles + "', Dept: '" + depts + "' > " + this.allowed);

      return this.allowed;
    },

    LoginMode: function() {
      return server.ApiLoginMode;
    },

    GetAppPageWidth: function() {
      var sidemenu = document.getElementById("sidemenu");
      var adj = 0;
      //if (sidemenu != null &&
      //    sidemenu._prevClass=="menu-collapsed") adj = 170;

      return (window.innerWidth
             || document.documentElement.clientWidth
             || document.body.clientWidth) - adj;
    },

    GetThumb: function(filename,thumb) {
      if (thumb != "" && thumb != null && thumb != 'undefined')
      {
         var p = filename.lastIndexOf('/');
         if (p > 0) return window.mediaserver + filename.substr(0,p+1) + thumb;
      }
      return "";
    },

    // --------------------------------- MINI FUNCTIONS ---------------------------------
    // Split MY-date (yyyy-mm-ddThh:mm:ss) into a real DATE: yyyy-mm-dd.
    showDate: function(date) {
       if(date == null) return "";
       else return date.split('T')[0];
    },

    // get logged'in user info: util.user('name')
    user: function(type) {
      if      (type == 'code')   return sessionStorage.getItem('login');
      else if (type == 'login')  return sessionStorage.getItem('login');
      else if (type == 'name')   return sessionStorage.getItem('name');
      else if (type == 'level')  return sessionStorage.getItem('userLevel');
      else if (type == 'avatar') return sessionStorage.getItem('avatar');
      else if (type == 'roles')  return sessionStorage.getItem('roles');
      else if (type == 'depts')  return sessionStorage.getItem('depts');
    },

    // CanUse: ANY of UserRole inside functRoles AND ANY of userDepts in funcDepts!
    canUse: function(funcRoles,funcDepts,userRoles,userDepts) {        
      //return true;
     
      let ok = (funcRoles == "" || userRoles == "super" || userRoles == "#S#"); // Empty? always allowed, "master": ALWAYS!    
      if (!ok) {
        let list = userRoles.split(' ');      // Split on space        
        for(let i = 0;i < list.length;i++) {
          if (funcRoles.includes(list[i])) ok = true;  // If item in funcRoles: OK!!!
        }
      }
        
      if (ok)
      {
        ok = (funcDepts == "" || userRoles == "super" || userRoles == "#S#"); // Empty? always allowed, "master": ALWAYS!
        if (!ok) {
          let list = userDepts.split(' ');    // Split on space
          for(let i = 0;i < list.length;i++) {
            if (funcDepts.includes(list[i])) ok = true; // If item in funcDepts: OK!!!
          }
        }
      }
      //console.log("AUT: " + funcRoles + "/" + userRoles + "  --  " + funcDepts + "/" + userDepts + " OK: " + ok);
      return ok;
    },

    setSessionValue: function(code,value) {
        window.sessionStorage.setItem(code,value); 
    },
    getSessionValue: function(code) {
        return window.sessionStorage.getItem(code); 
    },

};



// WEBPACK FOOTER //
// ./src/common/AppUtil.js